module.exports = __webpack_public_path__ + "static/media/ic_logo-horizontal.424d6efd.png";